/**
 * Human-readable message for the file-modal 'error' state — shown when openFile's fetch
 * retries are exhausted (auth/CORS/404/network failure). I7c: this used to be masked as a
 * silent 'binary' download stub; now the failure is visible, with its reason when available.
 * Pure — no React, no I/O.
 */
export function fileModalErrorMessage(error) {
  return (error && error.message) ? String(error.message) : 'Could not load this file.';
}
